import DelayedComponent from './delayed-components'

export default class DelayedGraphView extends DelayedComponent<any> {
  async getComponent() {
    const ComponentModule = await import(/* webpackChunkName: "GraphView" */ "components/graph-view")
    return ComponentModule.default
  }
}